export default __webpack_public_path__ + "static/media/Катон-Карагай.46a46389.svg";